import { render, staticRenderFns } from "./CreateTeam.vue?vue&type=template&id=f1a82942&scoped=true&"
import script from "./CreateTeam.vue?vue&type=script&lang=js&"
export * from "./CreateTeam.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeam.vue?vue&type=style&index=0&id=f1a82942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a82942",
  null
  
)

export default component.exports